// Reset geo closed flag on every page load
//localStorage.removeItem('geo-popup-closed');

console.log("VERSION 2026-09-26-REDIRECT-FIX");

async function getGelacyLocationCode() {
  try {
    const response = await fetch('https://geo.gelacy.app/');

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    return null;
  }
}

const setCountryCode = async () => {
  const locationData = await getGelacyLocationCode();
  if (locationData && locationData.country) {
    localStorage.setItem('userCountryCode', locationData.country);
  }
}
document.addEventListener('DOMContentLoaded', setCountryCode);

document.addEventListener("DOMContentLoaded", function () {
  const targetNode = document.body;
  const observer = new MutationObserver(() => {
    const geoPopup = document.getElementById("glc-geo");
    console.log("observer:", geoPopup);
    if (geoPopup) {
      setTimeout(() => {
        console.log("Running delayed geo override...");
        handleGeolocation();
      }, 1500); // try 1500–3000ms
      observer.disconnect();
    }
  });
  observer.observe(targetNode, { childList: true, subtree: true });

  setTimeout(() => {
    observer.disconnect();
    console.log("Observer disconnect");
  }, 15000);
});

// Detect when geo popup closes and mark it
document.addEventListener("click", function (e) {
  const geoPopup = document.getElementById("glc-geo");
  if (!geoPopup) return;

  // Adjust selector if your close button has a different class
  if (e.target.closest(".glc-geo-modal__close") ||
      e.target.closest(".glc-geo-close") ||
      e.target.closest("[data-geo-close]")) {

    localStorage.setItem("geo-popup-closed", "true");
  }
});

// ---------------------------------------------------------------------------
// Country -> destination map.
// Keys are ISO 3166-1 alpha-2 codes so they line up with the `countries`
// lookup at the bottom of this file. "International" is intentionally not an
// ISO code: it is a catch-all bucket, not a country.
// ---------------------------------------------------------------------------
const countryLinks = {
  HN: {
    country: "Honduras",
    url: "https://lovable.com.hn?glc=1",
    imageUrl: "https://app.gelacy.app/flags/hn.svg",
  },
  CR: {
    country: "Costa Rica",
    url: "https://lovable.co.cr?glc=1",
    imageUrl: "https://app.gelacy.app/flags/cr.svg",
  },
  DO: {
    country: "República Dominicana",
    url: "https://lovable.com.do?glc=1",
    imageUrl: "https://lovablehn.myshopify.com/cdn/shop/files/republica-dominicana.png",
  },
  NI: {
    country: "Nicaragua",
    url: "https://lovable.com.ni?glc=1",
    imageUrl: "https://cdn.shopify.com/s/files/1/0898/6473/2983/files/nicaragua.png?v=1738601061",
  },
  GT: {
    country: "Guatemala",
    url: "https://lovable.com.gt?glc=1",
    imageUrl: "https://app.gelacy.app/flags/gt.svg",
  },
  SV: {
    country: "El Salvador",
    url: "https://lovable.com.sv?glc=1",
    imageUrl: "https://cdn.shopify.com/s/files/1/0898/6473/2983/files/el-salvador.png?v=1738601061",
  },
  International: {
    country: "Internacional",
    url: "https://internacional.lovable.com.hn?glc=1",
    imageUrl: "https://lovablehn.myshopify.com/cdn/shop/files/internacional.png",
  },
};

// Resolve the destination the user actually picked.
// 1) the item they clicked (carries data-url)
// 2) fall back to whatever label the closed dropdown is displaying
const resolveGeoTarget = () => {
  const activeItem = document.querySelector(".glc-list-item__active");
  if (activeItem && activeItem.dataset.url) {
    return activeItem.dataset.url;
  }

  const shownName = document
    .querySelector(".glc-country__content .glc-country__name")
    ?.textContent.trim();

  const match = Object.values(countryLinks).find((c) => c.country === shownName);
  return match ? match.url : null;
};
// The app locks scroll via glc-geo-opened on <html>/<body>. If the modal never
// renders, or is removed while the class stays, the page is stuck. Release the
// lock when no visible modal justifies it.
const GEO_LOCK = { html: ["glc-geo-opened"], body: ["glc-geo-opened", "scroll-y-0"] };

const geoModalVisible = () => {
  const modal = document.querySelector(".glc-geo-modal, #glc-geo");
  if (!modal) return false;
  const cs = getComputedStyle(modal);
  if (cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0") return false;
  const r = modal.getBoundingClientRect();
  return r.width > 0 && r.height > 0;
};

let orphanStrikes = 0;
const releaseGeoLockIfOrphaned = () => {
  const locked =
    document.documentElement.classList.contains("glc-geo-opened") ||
    document.body.classList.contains("glc-geo-opened");

  if (!locked) { orphanStrikes = 0; return; }
  if (geoModalVisible()) { orphanStrikes = 0; return; }

  // Two consecutive strikes, so we don't unlock mid-animation.
  if (++orphanStrikes < 2) return;

  GEO_LOCK.html.forEach(c => document.documentElement.classList.remove(c));
  GEO_LOCK.body.forEach(c => document.body.classList.remove(c));
  orphanStrikes = 0;
  console.warn("GEO: released orphaned scroll lock");
};

document.addEventListener("DOMContentLoaded", () => {
  const timer = setInterval(releaseGeoLockIfOrphaned, 1000);
  setTimeout(() => clearInterval(timer), 30000);
  window.addEventListener("pageshow", releaseGeoLockIfOrphaned);
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) releaseGeoLockIfOrphaned();
  });
});

const handleGeolocation = () => {
  hideCurrency();
  setCountryName();

  console.log("HANDLE GEO RUNNING ON:", window.location.hostname);

  const countryList = document.querySelector(".glc-list");
  if (countryList) {
    countryList.innerHTML = "";

    for (const [code, { country, url, imageUrl }] of Object.entries(countryLinks)) {
      const listItem = document.createElement("div");
      listItem.className = "glc-list-item";
      listItem.setAttribute("glc-code", code);
      listItem.setAttribute("glc-name", country);
      // The destination lives on the element itself. The previous version
      // looked for an <a> inside the item, which this markup never contains,
      // so the apply handler bailed out before navigating.
      listItem.dataset.url = url;
      listItem.innerHTML = `
        <img class="glc-list-item__flag" src="${imageUrl}" alt="${code}">
        <span class="glc-list-item__name">${country}</span>
      `;

      listItem.addEventListener("click", function () {
        const currentCountry = document.querySelector(".glc-country__content");
        if (currentCountry) {
          currentCountry.innerHTML = `
            <img class="glc-country__flag" src="${imageUrl}" alt="${code}">
            <span class="glc-country__name">${country}</span>
          `;

          const activeItem = document.querySelector(".glc-list-item__active");
          if (activeItem) activeItem.classList.remove("glc-list-item__active");
          listItem.classList.add("glc-list-item__active");

          handleToggleDropdown();
        }
      });

      countryList.appendChild(listItem);
    }
  }

  const currentCountry = document.querySelector(".glc-country__content");
  if (currentCountry) {
    const currentCountryName = currentCountry
      .querySelector(".glc-country__name")
      ?.textContent.trim();
    const foundCountry = Object.values(countryLinks).find(
      (item) => item.country === currentCountryName
    );

    if (!foundCountry) {
      currentCountry.innerHTML = `
      <img class="glc-country__flag" src="${countryLinks.International.imageUrl}" alt="International">
      <span class="glc-country__name">${countryLinks.International.country}</span>
    `;
    }
  }

  const applyButton = document.querySelector(".glc-geo-modal__apply");
  if (applyButton && !applyButton.dataset.geoOverrideBound) {
    // Guard against double-binding if handleGeolocation ever runs twice.
    applyButton.dataset.geoOverrideBound = "true";

    applyButton.addEventListener(
      "click",
      function (e) {
        // The app's own handler no longer knows what is selected, because we
        // replaced its list. Take the click before it runs.
        e.preventDefault();
        e.stopImmediatePropagation();

        const target = resolveGeoTarget();

        if (!target) {
          console.warn("GEO: no destination resolved, aborting redirect");
          return;
        }

        const targetUrl = new URL(target);

        // Preserve existing query params
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.set("glc", "true");

        targetUrl.search = currentParams.toString();

        console.log("GEO: redirecting to", targetUrl.toString());
        window.location.href = targetUrl.toString();
      },
      true // capture phase, so we run before the app's listener
    );
  }
};

const handleToggleDropdown = () => {
  const element = document.querySelector(".glc-dropdown-expand__active");
  if (element) {
    element.classList.remove("glc-dropdown-expand__active");
  }
};

const hideCurrency = () => {
  const element = document.querySelector('.glc-geo-modal__form-item.glc-geo-currency')
  if (element) {
    element.style.display = 'none'
  }
}

const setCountryName = () => {
  const countryCode = localStorage.getItem('userCountryCode');
  if (!countryCode ) return;
  if (!countries[countryCode]) return;

  const modalDescription = document.querySelector('.glc-geo-modal__description');
  if (!modalDescription) return;

  const strongTag = modalDescription.querySelector('strong');
  if (!strongTag) return;

  strongTag.textContent = countries[countryCode].es || countries[countryCode].es;
}

const countries = {
  'AF': {
    en: 'Afghanistan',
    es: 'Afganistán'
  },
  'AX': {
    en: 'Åland Islands',
    es: 'Islas Åland'
  },
  'AL': {
    en: 'Albania',
    es: 'Albania'
  },
  'DZ': {
    en: 'Algeria',
    es: 'Argelia'
  },
  'AD': {
    en: 'Andorra',
    es: 'Andorra'
  },
  'AO': {
    en: 'Angola',
    es: 'Angola'
  },
  'AI': {
    en: 'Anguilla',
    es: 'Anguila'
  },
  'AG': {
    en: 'Antigua & Barbuda',
    es: 'Antigua y Barbuda'
  },
  'AR': {
    en: 'Argentina',
    es: 'Argentina'
  },
  'AM': {
    en: 'Armenia',
    es: 'Armenia'
  },
  'AW': {
    en: 'Aruba',
    es: 'Aruba'
  },
  'AC': {
    en: 'Ascension Island',
    es: 'Isla de la Ascensión'
  },
  'AU': {
    en: 'Australia',
    es: 'Australia'
  },
  'AT': {
    en: 'Austria',
    es: 'Austria'
  },
  'AZ': {
    en: 'Azerbaijan',
    es: 'Azerbaiyán'
  },
  'BS': {
    en: 'Bahamas',
    es: 'Bahamas'
  },
  'BH': {
    en: 'Bahrain',
    es: 'Baréin'
  },
  'BD': {
    en: 'Bangladesh',
    es: 'Bangladés'
  },
  'BB': {
    en: 'Barbados',
    es: 'Barbados'
  },
  'BY': {
    en: 'Belarus',
    es: 'Bielorrusia'
  },
  'BE': {
    en: 'Belgium',
    es: 'Bélgica'
  },
  'BZ': {
    en: 'Belize',
    es: 'Belice'
  },
  'BJ': {
    en: 'Benin',
    es: 'Benín'
  },
  'BM': {
    en: 'Bermuda',
    es: 'Bermudas'
  },
  'BT': {
    en: 'Bhutan',
    es: 'Bután'
  },
  'BO': {
    en: 'Bolivia',
    es: 'Bolivia'
  },
  'BA': {
    en: 'Bosnia & Herzegovina',
    es: 'Bosnia y Herzegovina'
  },
  'BW': {
    en: 'Botswana',
    es: 'Botsuana'
  },
  'BR': {
    en: 'Brazil',
    es: 'Brasil'
  },
  'IO': {
    en: 'British Indian Ocean Territory',
    es: 'Territorio Británico del Océano Índico'
  },
  'VG': {
    en: 'British Virgin Islands',
    es: 'Islas Vírgenes Británicas'
  },
  'BN': {
    en: 'Brunei',
    es: 'Brunéi'
  },
  'BG': {
    en: 'Bulgaria',
    es: 'Bulgaria'
  },
  'BF': {
    en: 'Burkina Faso',
    es: 'Burkina Faso'
  },
  'BI': {
    en: 'Burundi',
    es: 'Burundi'
  },
  'KH': {
    en: 'Cambodia',
    es: 'Camboya'
  },
  'CM': {
    en: 'Cameroon',
    es: 'Camerún'
  },
  'CA': {
    en: 'Canada',
    es: 'Canadá'
  },
  'CV': {
    en: 'Cape Verde',
    es: 'Cabo Verde'
  },
  'BQ': {
    en: 'Caribbean Netherlands',
    es: 'Caribe Neerlandés'
  },
  'KY': {
    en: 'Cayman Islands',
    es: 'Islas Caimán'
  },
  'CF': {
    en: 'Central African Republic',
    es: 'República Centroafricana'
  },
  'TD': {
    en: 'Chad',
    es: 'Chad'
  },
  'CL': {
    en: 'Chile',
    es: 'Chile'
  },
  'CN': {
    en: 'China',
    es: 'China'
  },
  'CX': {
    en: 'Christmas Island',
    es: 'Isla de Navidad'
  },
  'CC': {
    en: 'Cocos (Keeling) Islands',
    es: 'Islas Cocos (Keeling)'
  },
  'CO': {
    en: 'Colombia',
    es: 'Colombia'
  },
  'KM': {
    en: 'Comoros',
    es: 'Comoras'
  },
  'CG': {
    en: 'Congo - Brazzaville',
    es: 'Congo - Brazzaville'
  },
  'CD': {
    en: 'Congo - Kinshasa',
    es: 'Congo - Kinsasa'
  },
  'CK': {
    en: 'Cook Islands',
    es: 'Islas Cook'
  },
  'CR': {
    en: 'Costa Rica',
    es: 'Costa Rica'
  },
  'CI': {
    en: `Côte d'Ivoire`,
    es: 'Costa de Marfil'
  },
  'HR': {
    en: 'Croatia',
    es: 'Croacia'
  },
  'CW': {
    en: 'Curaçao',
    es: 'Curazao'
  },
  'CY': {
    en: 'Cyprus',
    es: 'Chipre'
  },
  'CZ': {
    en: 'Czechia',
    es: 'Chequia'
  },
  'DK': {
    en: 'Denmark',
    es: 'Dinamarca'
  },
  'DJ': {
    en: 'Djibouti',
    es: 'Yibuti'
  },
  'DM': {
    en: 'Dominica',
    es: 'Dominica'
  },
  'DO': {
    en: 'Dominican Republic',
    es: 'República Dominicana'
  },
  'EC': {
    en: 'Ecuador',
    es: 'Ecuador'
  },
  'EG': {
    en: 'Egypt',
    es: 'Egipto'
  },
  'SV': {
    en: 'El Salvador',
    es: 'El Salvador'
  },
  'GQ': {
    en: 'Equatorial Guinea',
    es: 'Guinea Ecuatorial'
  },
  'ER': {
    en: 'Eritrea',
    es: 'Eritrea'
  },
  'EE': {
    en: 'Estonia',
    es: 'Estonia'
  },
  'SZ': {
    en: 'Eswatini',
    es: 'Esuatini'
  },
  'ET': {
    en: 'Ethiopia',
    es: 'Etiopía'
  },
  'FK': {
    en: 'Falkland Islands',
    es: 'Islas Malvinas'
  },
  'FO': {
    en: 'Faroe Islands',
    es: 'Islas Feroe'
  },
  'FJ': {
    en: 'Fiji',
    es: 'Fiyi'
  },
  'FI': {
    en: 'Finland',
    es: 'Finlandia'
  },
  'FR': {
    en: 'France',
    es: 'Francia'
  },
  'GF': {
    en: 'French Guiana',
    es: 'Guayana Francesa'
  },
  'PF': {
    en: 'French Polynesia',
    es: 'Polinesia Francesa'
  },
  'TF': {
    en: 'French Southern Territories',
    es: 'Territorios Australes Franceses'
  },
  'GA': {
    en: 'Gabon',
    es: 'Gabón'
  },
  'GM': {
    en: 'Gambia',
    es: 'Gambia'
  },
  'GE': {
    en: 'Georgia',
    es: 'Georgia'
  },
  'DE': {
    en: 'Germany',
    es: 'Alemania'
  },
  'GH': {
    en: 'Ghana',
    es: 'Ghana'
  },
  'GI': {
    en: 'Gibraltar',
    es: 'Gibraltar'
  },
  'GR': {
    en: 'Greece',
    es: 'Grecia'
  },
  'GL': {
    en: 'Greenland',
    es: 'Groenlandia'
  },
  'GD': {
    en: 'Grenada',
    es: 'Granada'
  },
  'GP': {
    en: 'Guadeloupe',
    es: 'Guadalupe'
  },
  'GT': {
    en: 'Guatemala',
    es: 'Guatemala'
  },
  'GG': {
    en: 'Guernsey',
    es: 'Guernsey'
  },
  'GN': {
    en: 'Guinea',
    es: 'Guinea'
  },
  'GW': {
    en: 'Guinea-Bissau',
    es: 'Guinea-Bisáu'
  },
  'GY': {
    en: 'Guyana',
    es: 'Guyana'
  },
  'HT': {
    en: 'Haiti',
    es: 'Haití'
  },
  'HN': {
    en: 'Honduras',
    es: 'Honduras'
  },
  'HK': {
    en: 'Hong Kong SAR',
    es: 'Hong Kong (RAE)'
  },
  'HU': {
    en: 'Hungary',
    es: 'Hungría'
  },
  'IS': {
    en: 'Iceland',
    es: 'Islandia'
  },
  'IN': {
    en: 'India',
    es: 'India'
  },
  'ID': {
    en: 'Indonesia',
    es: 'Indonesia'
  },
  'IQ': {
    en: 'Iraq',
    es: 'Irak'
  },
  'IE': {
    en: 'Ireland',
    es: 'Irlanda'
  },
  'IM': {
    en: 'Isle of Man',
    es: 'Isla de Man'
  },
  'IL': {
    en: 'Israel',
    es: 'Israel'
  },
  'IT': {
    en: 'Italy',
    es: 'Italia'
  },
  'JM': {
    en: 'Jamaica',
    es: 'Jamaica'
  },
  'JP': {
    en: 'Japan',
    es: 'Japón'
  },
  'JE': {
    en: 'Jersey',
    es: 'Jersey'
  },
  'JO': {
    en: 'Jordan',
    es: 'Jordania'
  },
  'KZ': {
    en: 'Kazakhstan',
    es: 'Kazajistán'
  },
  'KE': {
    en: 'Kenya',
    es: 'Kenia'
  },
  'KI': {
    en: 'Kiribati',
    es: 'Kiribati'
  },
  'XK': {
    en: 'Kosovo',
    es: 'Kosovo'
  },
  'KW': {
    en: 'Kuwait',
    es: 'Kuwait'
  },
  'KG': {
    en: 'Kyrgyzstan',
    es: 'Kirguistán'
  },
  'LA': {
    en: 'Laos',
    es: 'Laos'
  },
  'LV': {
    en: 'Latvia',
    es: 'Letonia'
  },
  'LB': {
    en: 'Lebanon',
    es: 'Líbano'
  },
  'LS': {
    en: 'Lesotho',
    es: 'Lesoto'
  },
  'LR': {
    en: 'Liberia',
    es: 'Liberia'
  },
  'LY': {
    en: 'Libya',
    es: 'Libia'
  },
  'LI': {
    en: 'Liechtenstein',
    es: 'Liechtenstein'
  },
  'LT': {
    en: 'Lithuania',
    es: 'Lituania'
  },
  'LU': {
    en: 'Luxembourg',
    es: 'Luxemburgo'
  },
  'MO': {
    en: 'Macao SAR',
    es: 'Macao (RAE)'
  },
  'MK': {
    en: 'North Macedonia',
    es: 'Macedonia del Norte'
  },
  'MG': {
    en: 'Madagascar',
    es: 'Madagascar'
  },
  'MW': {
    en: 'Malawi',
    es: 'Malaui'
  },
  'MY': {
    en: 'Malaysia',
    es: 'Malasia'
  },
  'MV': {
    en: 'Maldives',
    es: 'Maldivas'
  },
  'ML': {
    en: 'Mali',
    es: 'Malí'
  },
  'MT': {
    en: 'Malta',
    es: 'Malta'
  },
  'MQ': {
    en: 'Martinique',
    es: 'Martinica'
  },
  'MR': {
    en: 'Mauritania',
    es: 'Mauritania'
  },
  'MU': {
    en: 'Mauritius',
    es: 'Mauricio'
  },
  'YT': {
    en: 'Mayotte',
    es: 'Mayotte'
  },
  'MX': {
    en: 'Mexico',
    es: 'México'
  },
  'MD': {
    en: 'Moldova',
    es: 'Moldavia'
  },
  'MC': {
    en: 'Monaco',
    es: 'Mónaco'
  },
  'MN': {
    en: 'Mongolia',
    es: 'Mongolia'
  },
  'ME': {
    en: 'Montenegro',
    es: 'Montenegro'
  },
  'MA': {
    en: 'Morocco',
    es: 'Marruecos'
  },
  'MZ': {
    en: 'Mozambique',
    es: 'Mozambique'
  },
  'MM': {
    en: 'Myanmar (Burma)',
    es: 'Birmania (Myanmar)'
  },
  'NA': {
    en: 'Namibia',
    es: 'Namibia'
  },
  'NR': {
    en: 'Nauru',
    es: 'Nauru'
  },
  'NP': {
    en: 'Nepal',
    es: 'Nepal'
  },
  'NL': {
    en: 'Netherlands',
    es: 'Países Bajos'
  },
  'NC': {
    en: 'New Caledonia',
    es: 'Nueva Caledonia'
  },
  'NZ': {
    en: 'New Zealand',
    es: 'Nueva Zelanda'
  },
  'NI': {
    en: 'Nicaragua',
    es: 'Nicaragua'
  },
  'NE': {
    en: 'Niger',
    es: 'Níger'
  },
  'NG': {
    en: 'Nigeria',
    es: 'Nigeria'
  },
  'NU': {
    en: 'Niue',
    es: 'Niue'
  },
  'NF': {
    en: 'Norfolk Island',
    es: 'Isla Norfolk'
  },
  'NO': {
    en: 'Norway',
    es: 'Noruega'
  },
  'OM': {
    en: 'Oman',
    es: 'Omán'
  },
  'PK': {
    en: 'Pakistan',
    es: 'Pakistán'
  },
  'PS': {
    en: 'Palestinian Territories',
    es: 'Territorios Palestinos'
  },
  'PA': {
    en: 'Panama',
    es: 'Panamá'
  },
  'PG': {
    en: 'Papua New Guinea',
    es: 'Papúa Nueva Guinea'
  },
  'PY': {
    en: 'Paraguay',
    es: 'Paraguay'
  },
  'PE': {
    en: 'Peru',
    es: 'Perú'
  },
  'PH': {
    en: 'Philippines',
    es: 'Filipinas'
  },
  'PN': {
    en: 'Pitcairn Islands',
    es: 'Islas Pitcairn'
  },
  'PL': {
    en: 'Poland',
    es: 'Polonia'
  },
  'PT': {
    en: 'Portugal',
    es: 'Portugal'
  },
  'QA': {
    en: 'Qatar',
    es: 'Catar'
  },
  'RE': {
    en: 'Réunion',
    es: 'Reunión'
  },
  'RO': {
    en: 'Romania',
    es: 'Rumania'
  },
  'RU': {
    en: 'Russia',
    es: 'Rusia'
  },
  'RW': {
    en: 'Rwanda',
    es: 'Ruanda'
  },
  'SX': {
    en: 'Sint Maarten',
    es: 'Sint Maarten'
  },
  'WS': {
    en: 'Samoa',
    es: 'Samoa'
  },
  'SM': {
    en: 'San Marino',
    es: 'San Marino'
  },
  'ST': {
    en: 'São Tomé & Príncipe',
    es: 'Santo Tomé y Príncipe'
  },
  'SA': {
    en: 'Saudi Arabia',
    es: 'Arabia Saudita'
  },
  'SN': {
    en: 'Senegal',
    es: 'Senegal'
  },
  'RS': {
    en: 'Serbia',
    es: 'Serbia'
  },
  'SC': {
    en: 'Seychelles',
    es: 'Seychelles'
  },
  'SL': {
    en: 'Sierra Leone',
    es: 'Sierra Leona'
  },
  'SG': {
    en: 'Singapore',
    es: 'Singapur'
  },
  'SK': {
    en: 'Slovakia',
    es: 'Eslovaquia'
  },
  'SI': {
    en: 'Slovenia',
    es: 'Eslovenia'
  },
  'SB': {
    en: 'Solomon Islands',
    es: 'Islas Salomón'
  },
  'SO': {
    en: 'Somalia',
    es: 'Somalia'
  },
  'ZA': {
    en: 'South Africa',
    es: 'Sudáfrica'
  },
  'GS': {
    en: 'South Georgia & South Sandwich Islands',
    es: 'Islas Georgias del Sur y Sandwich del Sur'
  },
  'KR': {
    en: 'South Korea',
    es: 'Corea del Sur'
  },
  'SS': {
    en: 'South Sudan',
    es: 'Sudán del Sur'
  },
  'ES': {
    en: 'Spain',
    es: 'España'
  },
  'LK': {
    en: 'Sri Lanka',
    es: 'Sri Lanka'
  },
  'BL': {
    en: 'St. Barthélemy',
    es: 'San Bartolomé'
  },
  'SH': {
    en: 'St. Helena',
    es: 'Santa Elena'
  },
  'KN': {
    en: 'St. Kitts & Nevis',
    es: 'San Cristóbal y Nieves'
  },
  'LC': {
    en: 'St. Lucia',
    es: 'Santa Lucía'
  },
  'MF': {
    en: 'St. Martin',
    es: 'San Martín'
  },
  'PM': {
    en: 'St. Pierre & Miquelon',
    es: 'San Pedro y Miquelón'
  },
  'VC': {
    en: 'St. Vincent & Grenadines',
    es: 'San Vicente y las Granadinas'
  },
  'SD': {
    en: 'Sudan',
    es: 'Sudán'
  },
  'SR': {
    en: 'Suriname',
    es: 'Surinam'
  },
  'SJ': {
    en: 'Svalbard & Jan Mayen',
    es: 'Svalbard y Jan Mayen'
  },
  'SE': {
    en: 'Sweden',
    es: 'Suecia'
  },
  'CH': {
    en: 'Switzerland',
    es: 'Suiza'
  },
  'TW': {
    en: 'Taiwan',
    es: 'Taiwán'
  },
  'TJ': {
    en: 'Tajikistan',
    es: 'Tayikistán'
  },
  'TZ': {
    en: 'Tanzania',
    es: 'Tanzania'
  },
  'TH': {
    en: 'Thailand',
    es: 'Tailandia'
  },
  'TL': {
    en: 'Timor-Leste',
    es: 'Timor Oriental'
  },
  'TG': {
    en: 'Togo',
    es: 'Togo'
  },
  'TK': {
    en: 'Tokelau',
    es: 'Tokelau'
  },
  'TO': {
    en: 'Tonga',
    es: 'Tonga'
  },
  'TT': {
    en: 'Trinidad & Tobago',
    es: 'Trinidad y Tobago'
  },
  'TA': {
    en: 'Tristan da Cunha',
    es: 'Tristán de Acuña'
  },
  'TN': {
    en: 'Tunisia',
    es: 'Túnez'
  },
  'TR': {
    en: 'Türkiye',
    es: 'Turquía'
  },
  'TM': {
    en: 'Turkmenistan',
    es: 'Turkmenistán'
  },
  'TC': {
    en: 'Turks & Caicos Islands',
    es: 'Islas Turcas y Caicos'
  },
  'TV': {
    en: 'Tuvalu',
    es: 'Tuvalu'
  },
  'UM': {
    en: 'U.S. Outlying Islands',
    es: 'Islas Ultramarinas de EE.UU.'
  },
  'UG': {
    en: 'Uganda',
    es: 'Uganda'
  },
  'UA': {
    en: 'Ukraine',
    es: 'Ucrania'
  },
  'AE': {
    en: 'United Arab Emirates',
    es: 'Emiratos Árabes Unidos'
  },
  'GB': {
    en: 'United Kingdom',
    es: 'Reino Unido'
  },
  'US': {
    en: 'United States',
    es: 'Estados Unidos'
  },
  'UY': {
    en: 'Uruguay',
    es: 'Uruguay'
  },
  'UZ': {
    en: 'Uzbekistan',
    es: 'Uzbekistán'
  },
  'VU': {
    en: 'Vanuatu',
    es: 'Vanuatu'
  },
  'VA': {
    en: 'Vatican City',
    es: 'Ciudad del Vaticano'
  },
  'VE': {
    en: 'Venezuela',
    es: 'Venezuela'
  },
  'VN': {
    en: 'Vietnam',
    es: 'Vietnam'
  },
  'WF': {
    en: 'Wallis & Futuna',
    es: 'Wallis y Futuna'
  },
  'EH': {
    en: 'Western Sahara',
    es: 'Sahara Occidental'
  },
  'YE': {
    en: 'Yemen',
    es: 'Yemen'
  },
  'ZM': {
    en: 'Zambia',
    es: 'Zambia'
  },
  'ZW': {
    en: 'Zimbabwe',
    es: 'Zimbabue'
  }
};